import React from 'react'

const ChatLoader = () => {
    return (
        <div className='d-flex flex-column align-items-center justify-content-center' style={{height: '250px'}}>
            <div className="spinner-grow text-primary" role="status"></div>
        </div>
    )
}

export default ChatLoader